var translations = {
    de: {
        title: 'Vorhaben',
        loanAmountLabel: 'Darlehensbetrag',
        loanAmountDescription: 'Geben Sie hier den Darlehensbetrag an, den Sie für Ihren Finanzierungswunsch benötigen.',
        loanTimeOfDemandLabel: 'Wann benötigen Sie das Darlehen?',
        loanTimeOfDemand_AT_ONCE: 'Sofort',
        loanTimeOfDemand_ONE_TO_THREE_MONTHS: 'In 1 - 3 Monaten',
        loanTimeOfDemand_FOUR_TO_SIX_MONTHS: 'In 4 - 6 Monaten',
        loanTimeOfDemand_MORE_THAN_SIX_MONTHS: 'Später als 6 Monate',
        loanTimeOfDemand_UNKNOWN: 'Weiß nicht',
        availableEquityLabel: 'Verfügbares Eigenkapital',
        objectTypesGroupLabel: 'Verwendungszweck',
        objectTypesGroupDescription: 'Die Konditionen der Kreditinstitute sind abhängig von dem Verwendungszweck.',
        objectTypesGroup_house: 'Haus',
        objectTypesGroup_apartments: 'Wohnung',
        objectTypesGroup_property: 'Grundstück',
        houseType_singleFamilyHouse: 'Einfamilienhaus',
        houseType_townhouse: 'Reihenhaus',
        houseType_semiDetached: 'Doppelhaushälfte',
        houseType_twoFamilyHouse: 'Zweifamilienhaus',
        houseType_appartmentHouse: 'Mehrfamilienhaus',
        reasonOfLoan_construction: 'Bauen',
        reasonOfLoan_purchaseExistingHome: 'Kaufen',
        reasonOfLoan_modernization: 'Modernisieren',
        reasonOfLoan_prolongation: 'Anschlussfinanzierung / Umschuldung',
        reasonOfLoan_procurement: 'Kapitalbeschaffung',
        areaInSqmLabel: 'Wohnfläche in qm',
        areaInSqmPlaceholder: '100,00',
        yearOfConstructionLabel: 'Baujahr',
        yearOfConstructionPlaceholder: String(new Date().getFullYear()),
        marketValueLabel: 'Marktwert',
        projectStatusLabel: 'Wie weit ist Ihr Vorhaben vorangeschritten?',
        projectStatus_PARCEL_FOUND: 'Grundstück gefunden',
        projectStatus_NOTARY: 'Notartermin vereinbart',
        projectStatus_PARCEL_OWNED: 'Grundstück erworben',
        projectStatus_DEVELOPER_CONTRACTED: 'Bauträgervertrag geschlossen',
        projectStatus_OBJECT_FOUND: 'Objekt gefunden',
        projectStatus_OBJECT_INSPECTED: 'Objekt besichtigt',
        projectStatus_NEGOTIATION: 'In Kaufpreisverhandlung',
        projectStatus_PROPERTY_OBJECT_FOUND: 'Grundstück gefunden',
        projectStatus_PROPERTY_OBJECT_INSPECTED: 'Grundstück besichtigt',
        isPostalAddressKnownLabel: 'Haben Sie bereits ein Wunschobjekt gefunden?',
        isPostalAddressKnownDescription: 'Diese Angabe ist für die Ermittlung der Konditionen nötig.',
        yes: 'Ja',
        no: 'Nein',
        objectTypeOfUseLabel: 'Wie wird die Immobilie genutzt?',
        objectTypeOfUseDescription: 'Die Konditionen der Kreditinstitute sind abhängig von der Nutzungsart der Immobilie.',
        objectTypeOfUse_selfUsed: 'Selbstnutzung',
        objectTypeOfUse_rented: 'Vermietung',
        objectTypeOfUse_partlyRented: 'Beides',
        isExistingLoanPresentedLabel: 'Besteht noch eine Baufinanzierung',
        fixedInterestRateUntilLabel: 'Zinsbindung bis',
        residualDebtLabel: 'Aktuelle Restschuld',
        monthlyRepaymentLabel: 'Monatliche Rate',
        baseCostLabel_buyer: 'Kaufpreis',
        baseCostLabel_owner: 'Baukosten',
        baseCostLabel_modernizator: 'Modernisierungskosten',
        baseCostDescription: "Diese Angabe ist f\u00FCr die Ermittlung der Konditionen n\u00F6tig. Bitte geben Sie hier den Betrag an, den Sie finanzieren m\u00F6chten.",
        additionalCost_landPrice: 'Grundstückskaufpreis',
        additionalCost_modernization: 'Modernisierungskosten',
        submit: 'Weiter',
        submitDescription: 'kostenlos und unverbindlich',
    },
};
export default translations;
